module.exports = __webpack_public_path__ + "494cd07c/img/share-action-icon.9c12578c.svg";